<!-- Divider -->
<div class="calsoft-vertical-navigation-item-wrapper divider"></div>
